import {
  FinanceCalculatorTheme,
  FcWidgetScreenClasses,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const widgetScreenStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcWidgetScreenClasses
>(
  ({ palette, breakpoints }) => ({
    container: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
    },
    paperContainer: {
      margin: 'auto',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      boxShadow: 'none',
      background: palette.background.default,
      minHeight: '100vh',
      [breakpoints.down(breakpoints.values.sm)]: {
        maxWidth: 'initial',
        maxHeight: 'initial',
        overflow: 'auto',
      },
    },
    breakdownPaperContainer: {
      minHeight: 'initial',
      '& fieldset': {
        border: 'none',
      },
    },
    loadingOverlay: {
      minHeight: '100vh',
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      height: '100%',
      width: '100%',
      background: 'rgba(0,0,0,0.2)',
      zIndex: 100,
    },
    breakdownLoadingOverlay: {
      background: palette.background.default,
    },
    globalLoader: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 200,
      position: 'fixed',
      background: 'rgb(0,0,0,.4)',
      borderRadius: '9999px',
      width: '50px',
      height: '50px',
      '& > *': {
        marginTop: 5,
        marginLeft: 5,
      },
    },
    loaderContainer: {},
    childrenWrapper: {},
    reffineLoader: {
      zIndex: 2,
    },
    reffineLoadingOverlay: {
      zIndex: 2,
    },
  }),
  { name: 'FC_WidgetScreen' }
)

export default widgetScreenStyles
